import { useSelect } from "@pankod/refine-core";
import {
  Checkbox,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@pankod/refine-mui";
import { useState } from "react";
import { toast } from "react-toastify";

import AutoGeneratedInputCmp from "../../components/auto-generated-input/AutoGeneratedInputCmp";
import SimpleUploadZone from "../../components/SimpleUploadZone";

export default function CompFields({
  register,
  errors,
  control,
  getValues,
  setValue,
  isSeller,
}) {
  const [businessView, setBusinessView] = useState();

  const { options: municipalities } = useSelect({
    resource: "municipalities",
    optionLabel: "name",
    optionValue: "id",
  });

  const { queryResult } = useSelect({
    resource: "user-categories",
  });

  const user_categories = queryResult.data?.data
    .filter((item) => item.is_seller === isSeller)
    .map((item) => ({
      label: item.name,
      value: item.id,
    }));

  // base fields
  const fields = [
    {
      label: "Nome",
      name: "first_name",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Cognome",
      name: "last_name",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Azienda",
      name: "company",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "P.IVA",
      name: "vat",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "Indirizzo",
      name: "address",
      required: true,
      type: "text",
      md: 12,
      style: { marginBottom: "20px" },
    },

    {
      label: "Comune",
      name: "municipality",
      required: true,
      type: "select",
      options: municipalities,
      md: 6,
    },
    {
      label: "Città",
      name: "city",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "CAP",
      name: "zip_code",
      required: true,
      type: "number",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Telefono",
      name: "phone",
      required: true,
      type: "number",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Email",
      name: "email",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Categoria",
      name: "user_category",
      required: true,
      type: "select",
      options: user_categories,
      md: 6,
    },
  ];

  if (!user_categories) return null;

  return (
    <Grid item xs={12}>
      <Grid container spacing={2} style={{ padding: "30px" }}>
        {fields.map((field, index) => {
          return (
            <AutoGeneratedInputCmp
              key={index}
              {...field}
              register={register}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
            />
          );
        })}
        <Hidden>
          <TextField
            {...register("status")}
            hidden
            required={true}
            defaultValue="submitted"
            type="text"
            style={{ height: "0", display: "none" }}
          />
          <Checkbox
            {...register("is_seller")}
            checked={isSeller}
            type="checkbox"
            style={{ height: "0", display: "none" }}
          />
          <Checkbox
            {...register("accepted_tos")}
            checked={true}
            type="checkbox"
            style={{ height: "0", display: "none" }}
          />
        </Hidden>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{ padding: "30px" }}
        justifyContent="start"
        gap={4}
        alignItems="center"
      >
        <Typography variant="h6">Visura Camerale</Typography>

        <SimpleUploadZone
          label="Aggiungi"
          onChange={async (file) => {
            // await axios.post("/api/upload", {
            //   data: {
            //     name: "visura_camerale",
            //     attachment: file.id,
            //     alternativeText: "submitted",
            //     caption: "prova",
            //   },
            // });
            toast.success("Documento caricato con successo");
            setValue("business_view", file.id);
            setBusinessView(file.id);

            // await new Promise((resolve) => setTimeout(resolve, 1000));
            // window.location.reload();
          }}
        />
      </Grid>
    </Grid>
  );
}
